import { reactive, ref, nextTick, watch } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4fa4d548"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-list"
};
const _hoisted_4 = {
  class: "notice-title"
};
const _hoisted_5 = {
  class: "wechat-pkg-content"
};
const _hoisted_6 = {
  class: "pkg-content"
};
const __default__ = {
  name: 'WxPayBaseConfig'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { message } from 'ant-design-vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['setVisible', 'submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const wechatForm = reactive({
      channelRate: 1,
      pkgList: [{
        pkg: '',
        appId: '',
        appSecret: ''
      }],
      mchId: null,
      apiKey: '',
      mchName: '',
      merchants: '',
      rate: 0.009
    }); // 微信app支付
    const wechatRef = ref(null); // 微信app支付ref
    const channelRateList = ref([]); // 费率列表
    const addWechatPkg = () => {
      var _wechatForm$pkgList;
      if (!((_wechatForm$pkgList = wechatForm.pkgList) !== null && _wechatForm$pkgList !== void 0 && _wechatForm$pkgList.length)) {
        wechatForm.pkgList.push({
          pkg: '',
          appId: '',
          appSecret: ''
        });
      } else {
        let flag = wechatForm.pkgList.some(item => !item.pkg || !item.appId || !item.appSecret);
        if (!flag) {
          wechatForm.pkgList.push({
            pkg: '',
            appId: '',
            appSecret: ''
          });
          nextTick(() => {
            var _document$querySelect;
            (_document$querySelect = document.querySelector('.wechat-pkg-content')) === null || _document$querySelect === void 0 || _document$querySelect.scrollTo(0, 9999);
          });
        } else {
          message.error('请先填写完整包名信息');
        }
      }
    }; // 添加微信包名
    const deleteWechatPkg = index => {
      wechatForm.pkgList.splice(index, 1);
    }; // 删除微信包名
    const validateForm = () => {
      var _wechatRef$value;
      (_wechatRef$value = wechatRef.value) === null || _wechatRef$value === void 0 || _wechatRef$value.validate().then(() => {
        if (wechatForm.pkgList.some(item => !item.pkg || !item.appSecret || !item.appId)) {
          message.error('请完善微信支付配置');
        } else {
          emit('submitForm', wechatForm);
        }
      }).catch(e => void 0);
    }; // 验证微信支付配置
    watch(() => props.detailForm, n => {
      if (n) {
        wechatForm.channelRate = n.channelRate;
        wechatForm.mchId = n.mchId;
        wechatForm.apiKey = n.apiKey;
        wechatForm.mchName = n.mchName;
        wechatForm.merchants = n.merchants;
        wechatForm.pkgList = n.pkgList || [{
          pkg: '',
          appId: '',
          appSecret: ''
        }];
        wechatForm.rate = n.channelRate;
        channelRateList.value = n.channelRateList;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: wechatForm,
        rules: __props.rules,
        ref_key: "wechatRef",
        ref: wechatRef,
        name: "wechat-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wechatForm.mchName,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => wechatForm.mchName = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "merchants",
          label: "商户号："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: wechatForm.merchants,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => wechatForm.merchants = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "rate",
          label: "费率："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: wechatForm.rate,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => wechatForm.rate = $event),
            options: channelRateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("使用微信支付功能将收取0.9%手续费")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "apiKey",
          label: "API Key："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_input, {
            value: wechatForm.apiKey,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => wechatForm.apiKey = $event),
            disabled: ""
          }, null, 8, ["value"]), _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_createTextVNode("复制")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "copy",
              "class-name": "copy-icon",
              onClick: _cache[4] || (_cache[4] = $event => _unref(copy)(wechatForm.apiKey))
            })]),
            _: 1
          })]), _createElementVNode("div", _hoisted_4, [_createTextVNode(" 请复制该密钥并配置到微信商户平台-账号中心-API安全-设置APIv2密钥； "), _createVNode(_component_a_button, {
            class: "img-btn",
            type: "link",
            onClick: _cache[5] || (_cache[5] = $event => emit('setVisible', true))
          }, {
            default: _withCtx(() => [_createTextVNode("图片指引")]),
            _: 1
          })])]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wechatForm.pkgList, (item, index) => {
          var _wechatForm$pkgList2;
          return _openBlock(), _createElementBlock("div", {
            class: "flex-list pkg-list pkg-color",
            key: index
          }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_a_form_item, {
            required: index === 0,
            label: "包名："
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: item.pkg,
              "onUpdate:value": $event => item.pkg = $event,
              valueModifiers: {
                trim: true
              },
              disabled: ""
            }, null, 8, ["value", "onUpdate:value"])]),
            _: 2
          }, 1032, ["required"]), _createVNode(_component_a_form_item, {
            required: index === 0,
            label: "AppID："
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: item.appId,
              "onUpdate:value": $event => item.appId = $event,
              valueModifiers: {
                trim: true
              },
              disabled: ""
            }, null, 8, ["value", "onUpdate:value"])]),
            _: 2
          }, 1032, ["required"]), _createVNode(_component_a_form_item, {
            required: index === 0,
            label: "AppSecret："
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: item.appSecret,
              "onUpdate:value": $event => item.appSecret = $event,
              valueModifiers: {
                trim: true
              },
              disabled: ""
            }, null, 8, ["value", "onUpdate:value"])]),
            _: 2
          }, 1032, ["required"])]), index + 1 === ((_wechatForm$pkgList2 = wechatForm.pkgList) === null || _wechatForm$pkgList2 === void 0 ? void 0 : _wechatForm$pkgList2.length) && index !== 0 && !item.id ? (_openBlock(), _createBlock(SvgIcon, {
            key: 0,
            "icon-class": "close",
            "class-name": "close-icon",
            onClick: $event => deleteWechatPkg(index)
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)]);
        }), 128))]), false ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "add-btn",
          onClick: addWechatPkg
        }, {
          icon: _withCtx(() => [_createVNode(SvgIcon, {
            "icon-class": "add_no_color",
            "class-name": "add-icon"
          })]),
          default: _withCtx(() => [_createTextVNode(" 新增包名 ")]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});